import styled, { css } from 'styled-components'

import { Cover, Reset, TransitionPrimary } from '@/lib/mixins'

export const PaymentMethodLabel = styled.div`
  font-size: 1.75rem;
  font-weight: 600;
`

export const PaymentMethodIcon = styled.img`
  margin-left: auto;
  height: 48px;
  width: ${props => `${props.width}px`};
  object-fit: contain;
`

export const PaymentMethodBorder = styled.div`
  ${Cover('10px')}
  border: 2px solid ${props => props.theme.color.line};
`

export const PaymentMethodOutline = styled.div`
  ${Cover()}
  border: 4px solid ${props => props.theme.color.primary};
  opacity: 0;
  transform: scale(1.1);
  ${TransitionPrimary('transform, opacity')}
`

export const PaymentMethodWrapper = styled.button`
  ${Reset('button')}
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 56px;
  height: 180px;
  margin: 0 auto 1rem auto;

  ${props =>
    props.active &&
    css`
      ${PaymentMethodOutline} {
        opacity: 1;
        transform: scale(1);
      }
    `};
`
